import script from "./OwnerProjectManager.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnerProjectManager.vue?vue&type=script&setup=true&lang=js"

import "./OwnerProjectManager.vue?vue&type=style&index=0&id=1abc680a&lang=css"

const __exports__ = script;

export default __exports__